import ChevronDownSvg from '@/icons/chevron-down.svg?react'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const RepoItemUI: FunctionalComponent<{
  fullName: string
}> = props => {
  return (
    <div
      class={classNames(styles.root, styles.active, styles.ui)}
    >
      <div class={styles.header}>
        <div class={styles.left}>
          <ChevronDownSvg
            class={styles.chevron}
          />

          <div class={styles.name}>
            {props.fullName}
          </div>
        </div>
      </div>

      <div class={styles.content}>
        {props.children}
      </div>
    </div>
  )
}
